import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import AllQuestions from './Questions/AllQuestions.js';

import {Howl, Howler} from 'howler';



const Hashids = require('hashids/cjs')
const hashids = new Hashids()

const twitterShareText = "Are+you+smart+enough+to+not+accept+cookies?+Play+%23TermsAndConditionsApply - a mini-game about devious popups."



const shareURL = "https://termsandconditions.game"

const facebookShareURL = "https://www.facebook.com/dialog/share?app_id=469512504377527&display=popup&href=https%3A%2F%2Ftermsandconditions.game&redirect_uri=https%3A%2F%2Ftermsandconditions.game"


export default class ScoreCard extends React.Component {

     constructor(props){
        super(props);
        this.state = {
            nextButton: {},
            score: 0,
            total_time: 0,
            rank_message: "",
            message: "",
            fail_messages: [],
            percentages_per_type: [],
            feedback: [<h2></h2>],
            ticks: 0,
            shareClaim: "",
            all_questions: [],
            replay_question: <div></div>,
            successSound: new Howl({src: ['./sounds/success.mp3']}),
            failSound: new Howl({src: ['./sounds/fail2.mp3']}),
            popSound: new Howl({src: ['./sounds/pop2.mp3']}),
            pos: 0,
            new_answers: [],
            showing_question: -1
        }
      }
      



      //handle the click on one of the buttons
      handleReplayClick = (e) => {

        
        
          
          var question_number = e.target.getAttribute("question")
          var showing_question = e.target.getAttribute("showing_question")

         

          console.log("replay question", question)

          var question = this.state.all_questions[question_number]
          

          

          this.setState({
            pos: 0,
            replay_question: <div class="extra_holder">{question}</div>,
            showing_question: showing_question

          })





          let soundId = this.state.popSound.play();

          this.state.successSound.rate(1, soundId);

          

      }







      saveScore = (score, total_time) => {



        //console.log("saving score", score, total_time)

        //console.log("this.props.correct_incorrect_list", this.props.correct_incorrect_list.join(","))

        // Get the passwords and store them in state
        fetch('/finished/'+score+"/"+(total_time/1000).toFixed(2)+"/"+this.props.correct_incorrect_list.join(","))
          .then(res => res.json())
          .then(result => this.setState({ result }));

      }


        //handle the click on one of the buttons
      shareToTwitter = (e) => {

        window.plausible('share_twitter');

        window.open("http://twitter.com/share?text=" + twitterShareText + " " + this.state.shareClaim + "&url=" + shareURL);

      };


      shareToFacebook = (e) => {

        window.plausible('share_facebook');

        window.open(facebookShareURL);

      };



      goToTwitter = (e) => {



        window.plausible('share_facebook');

        window.open("https://twitter.com/" + (e.target.innerHTML.replace("@","")));

      };


      


      copyURL = (e) => {

        window.plausible('share_copy');

        var copyText = document.getElementById("shareURL");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */
      
        /* Copy the text inside the text field */
        document.execCommand("copy");
       
      };



      getRanking = (score, total_time) => {

        //console.log("getting ranking for", '/rank/'+score+"/"+total_time)


        // Get the rank
        fetch('/rank/'+score+"/"+(total_time/1000).toFixed(2))
          .then(res => res.json())
          .then(rank => {

            console.log("rank", rank)


            var feedback = [].concat(this.state.feedback);


            

              feedback.push(<h2 class="end">That's better than {rank.score_grade}% of players</h2>)
              feedback.push(<h2 class="end">You took {(total_time/1000).toFixed(2)} seconds to complete the game</h2>)
              feedback.push(<h2 class="end">That's faster than {rank.time_grade}% of players</h2>)
             

              
              

              var percents_and_types = []

              for (var type in this.state.percentages_per_type) {

                    var percent = this.state.percentages_per_type[type]

                    //console.log("percent for " + type + " is " + percent)

                    percents_and_types.push({percent: percent, type: type})

                    if(percent > 10)
                    {
                        //feedback.push(<h2>You did particularly well with {type} questions</h2>)
                    }
                
                }


            percents_and_types.sort((a,b) => (a.percent > b.percent) ? 1 : ((b.percent > a.percent) ? -1 : 0))

            var worst = percents_and_types[0]
            var best = percents_and_types[percents_and_types.length-1]

            if(best.percent > 50)
            {
                feedback.push(<h2 class="end">You did particularly well with {best.type} questions</h2>)
            }

            if(worst.percent < 50)
            {
                feedback.push(<h2 class="end">We caught you out with {worst.type} questions</h2>)
            }
           


            //console.log("percents_and_types",percents_and_types)

            feedback.push(<h2 class="end">Thanks for playing Terms And Conditions Apply</h2>)


            feedback.push(<h2 class="end">Please share with friends so we can extract their data*</h2>)

            feedback.push(<h2 class="end">*Disclaimer: Game does not extract real data</h2>)

            



          

            

           //here
           


            this.setState({
                feedback: feedback,
                shareClaim: "I+did+better+than+" + rank.score_grade + "%25+of+people"
            })


              
          })
          

      }
      
      

      componentWillUnmount(){
        clearInterval(this.intervalId);
      }



      timer() {

        

        this.setState({ticks: this.state.ticks + 1})

        //console.log("this.state.ticks", this.state.ticks)

      }


      componentDidMount() {


        window.plausible('completed');


        const setResult = (result, question) => {


          let new_answers = this.state.new_answers
          

          if(result)
          {
            console.log("got it right")

            let soundId = this.state.successSound.play();

            this.state.successSound.rate(1, soundId);

            this.setState({

          
              background: "#46ce58"

            })

            new_answers[this.state.showing_question] = 'correct';




          }
          else
          {
            console.log("got it wrong")

            this.state.failSound.play();

             this.setState({

                background: "#f3224f"

              })


              new_answers[this.state.showing_question] = 'incorrect';


          }


          this.setState({
            new_answers: new_answers,
          })

          console.log(new_answers)



          setTimeout(() => { 

            this.setState({
           
              background: "#fff",
              replay_question: <div></div>
          
            })

          }, 500)




          this.setState({

            pos: -20,
            replay_question : <div></div>
          })
        }

        const getPos = (question) => {
          
          return this.state.pos

        }

      

        this.setState({
          all_questions: AllQuestions(setResult, getPos)[0]
        })


        this.intervalId = setInterval(this.timer.bind(this), 1190);


        var question_types_counts = this.props.question_types_counts;

        var question_types = this.props.question_types;

        



        //console.log("question_types_counts----: ", question_types_counts)

        //console.log("question_types----: ", question_types)


        var correct_per_category = []
        for(var i = 0; i < question_types.length; i++)
            {
                correct_per_category[question_types[i]] = 0;
            }

        

        //console.log("correct_per_category----: ", correct_per_category)



            
   
        var counts = {};
        this.props.fails.forEach(function(x) { counts[x] = (counts[x] || 0)+1; });

        //var fail_items = [];

        //console.log(counts)


        var fail_messages = []



        var per_question = 1000;

        var actual_score = 0;

        var time_bonus = 0;

        var streak_bonus = 0;

        var correct = 0;

        //console.log(this.props.score)

        

        var total_time = 0

        //calculate scores
        for(var i = 0; i < this.props.score.length; i ++)
        {
            
            if(this.props.score[i].amount > 0)
            {
                correct ++;

                for(var t = 0; t < this.props.score[i].types.length; t ++)
                {
                    correct_per_category[this.props.score[i].types[t]] += 1

                    //console.log("got one right with category: " + this.props.score[i].types[t])
                }

                

                total_time += this.props.score[i].time

                let this_actual_score = Math.round(this.props.score[i].amount * per_question)

                let this_time_bonus = Math.round(this.props.score[i].amount * per_question / this.props.score[i].time * 1000)

                let this_streak_bonus = Math.round((this_actual_score) * this.props.score[i].multiplier)

                actual_score += this_actual_score
                time_bonus += this_time_bonus
                streak_bonus += this_streak_bonus
            }

           

        }


        //console.log("correct_per_category", correct_per_category)

        var percentages_per_type = []

        for(var i = 0; i < this.props.question_types.length; i ++)
        {
            var this_type = this.props.question_types[i];

            //console.log("type:", this.props.question_types[i])


            percentages_per_type[this_type] = correct_per_category[this_type] / this.props.question_types_counts[this_type] * 100


        }

        //console.log("percentages_per_type: ", percentages_per_type);





        var total_score = actual_score + time_bonus + streak_bonus


        for (var key in counts) {
            //console.log(key + ": " + counts[key]);


            var times = ""

            if(counts[key] > 1)
            {
                times = counts[key] + " times"
            }

            fail_messages.push( <div class="fail_message">{key}</div> )
        }

        //console.log("this.props.fails: ", this.props.fails);

        var percent = Math.round(correct / this.props.score.length * 100)


        
        //

        var incorrect = (this.props.score.length-correct)

        var message = "and you were kind enough to give it to us "

        if(incorrect == 1)
        {
            message = "and you gave it to us only once!"
        }
        else if(incorrect > 1)
        {
            message += incorrect + " times."
        }
        else
        {
            message = "Unfortunately, we were unable to access any of it."
        }


        window.plausible('score', {props:{correct: correct, total_time: total_time, fail_messages: fail_messages, percentages_per_type: percentages_per_type}});


        this.setState({
            feedback: [<h2 class="end">We attempted to access your data {this.props.score.length} times</h2>, <h2 class="end">{message}</h2>],
            message: message, 
            fail_messages: fail_messages,
            percentages_per_type: percentages_per_type
        })


        //this.props.score.length-correct
        this.saveScore(correct, total_time);
        this.getRanking(correct, total_time);


      }

    render() {



    
  

            

        //question_types_counts is an object with enums of each type of question and the number of quesions there are for each

        


    //handle the click on one of the buttons
    const handleClick = (e) => {

      this.props.continue()

    }




    var button = <Button onClick={handleClick} className="mr-3" size="lg">Level Up</Button>
    
    if(this.props.continue == false)
    {
        button = <br />
        
    }       

    




        var failed_questions_messages = [];

        failed_questions_messages.push(<h2></h2>)

        failed_questions_messages.push(<h2>Retry incorrect questions</h2>)

        //console.log("failed_questions: ", this.props.failed_questions)
        for(var i=0; i < this.props.failed_questions.length; i++)
        {

          //console.log("this.state.new_answers", this.state.new_answers)

          //console.log("i", i)

          //console.log("this.state.new_answers[i]", this.state.new_answers[i])
      
          let new_answer = this.state.new_answers[i]
          let new_answer_result;

          if(new_answer == "correct")
          {
            new_answer_result = "secondary"
          }
          else if(new_answer == "incorrect")
          {
            new_answer_result = "info"
          }
          else
          {
            new_answer_result = "danger"
          }


          failed_questions_messages.push(<div new_answer_result={new_answer_result} class="incorrect_questions"><Button variant={new_answer_result} showing_question={i} question={this.props.failed_questions[i]} onClick={this.handleReplayClick} className="m-2">Replay Question {this.state.all_questions.length-this.props.failed_questions[i]}</Button></div>)
        }






     

        return (
        
              <header className="App-header justify-content-center">

              <div class="scorecard" style={{backgroundColor: this.state.background}}>

             
                 

                  <h1>{this.props.title}</h1>
                  
                  {this.state.feedback.slice(0, this.state.ticks)}


                  <div>
                            <Button className="m-3 primary-outline-btn" size="" onClick={this.shareToTwitter}>twitter</Button>

                            <Button className="m-3 primary-outline-btn" size="" onClick={this.shareToFacebook}>facebook</Button>

                            <Button className="m-3 primary-outline-btn"  size="" onClick={this.copyURL}>copy url</Button>
                        </div>


                  


                    
                        <div id="twitter_handles">

                    <p class="scorecard-credits">Terms and Conditions Apply was created by <a target="_blank" href="https://twitter.com/wklondon">@WKLondon</a>, <a target="_blank" href="https://twitter.com/jonplackett">@Jonplackett</a>, <a target="_blank" href="https://twitter.com/AlexBellos">@AlexBellos</a> and <a target="_blank" href="https://twitter.com/iam_adam">@iam_adam</a>. With inspiration from <a target="_blank" href="https://darkpatterns.org">darkpatterns.org</a>, <a target="_blank" href="https://reddit.com/r/darkpatterns">r/darkpatterns</a> and pretty much every website on the internet</p>


                      
                    </div>




                  {failed_questions_messages}


                

                


                  <input type="text" value={shareURL} id="shareURL"></input>

                  



                  <br />

                <div className="d-flex justify-content-center">
                    <ButtonToolbar>
                        {button}
                    </ButtonToolbar>
                    </div>




                  {this.state.replay_question}

            </div>     
            </header>
      
        )
    }
  }
  
